import { firstBy } from "thenby";

import { dayjs } from "@thalamos/common";
import type {
  ExtendedVisionUser,
  IncidentWorkItemWithContext,
} from "@thalamos/vision-common";
import { calculateActions, defaultActions, tk } from "@thalamos/vision-common";

import type { IncidentTableRow } from "../../../components/IncidentWorkItems/IncidentTable/types.js";
import { extractIncidentDisplayValues } from "../../../components/IncidentWorkItems/IncidentWorkItemCard/extractIncidentDisplayValues.js";

/** Build rows for the archive incident table. */
export function buildArchiveRows({
  incidents,
  user,
  onDownloadPdf,
  t,
}: {
  incidents: IncidentWorkItemWithContext[];
  user: ExtendedVisionUser | undefined;
  onDownloadPdf: (incident: IncidentWorkItemWithContext) => Promise<void>;
  t: (key: string, options?: Record<string, unknown>) => string;
}): IncidentTableRow[] {
  return incidents
    .toSorted(
      firstBy((incident) => incident.incidentWorkItem.createdAt, "desc"),
    )
    .map((incident) => {
      const displayValues = extractIncidentDisplayValues(incident, t);

      const actions = user
        ? calculateActions({
            incidentWorkItem: incident,
            user,
            asOfDateTime: dayjs(),
          })
        : defaultActions;

      return {
        id: incident.incidentWorkItem.id,
        ...displayValues,

        isPendingTransfer: false,

        primaryButton: {
          label: tk("common.download"),
          disabled: !actions.pdf.canDownload,
          onClick: () => onDownloadPdf(incident),
        },
      };
    });
}
